import React, { useState } from "react";

import {
  Container,
  ContainerLogin,
  FieldText,
  ImageLogin,
  LoginForm,
  LogoContainer,
  ShowPassword,
  TextInput,
  WrapLogin,
} from "./styles";

//Images
import logo from "@assets/logoCentral.svg";
import imageLogin from "@assets/imageLogin.svg";
import showToast from "../../helpers/showToast";
import useUser from "@hooks/useUser";
import Button from "@components/Button/Button";

const LoginPage = () => {
  const { loading, loginUser } = useUser();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleInputChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleInputChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      return showToast("Preencha todos os campos", "error");
    }

    await loginUser(email, password);
  };

  return (
    <Container>
      <ImageLogin>
        <img style={{ resize: "inherit" }} src={imageLogin} alt="Login Logo" />
      </ImageLogin>
      <ContainerLogin>
        <WrapLogin>
          <LogoContainer>
            <img style={{ height: "100%", width: "100%" }} src={logo} alt="Login Logo" />
          </LogoContainer>
          <LoginForm onSubmit={handleLogin}>
            <FieldText>E-mail</FieldText>
            <TextInput>
              <input name="email" onChange={handleInputChangeEmail} placeholder="E-mail" />
            </TextInput>

            <FieldText>Senha</FieldText>
            <TextInput>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                onChange={handleInputChangePassword}
                placeholder="Senha"
              />
            </TextInput>

            <ShowPassword onClick={() => setShowPassword(!showPassword)}>
              <p>{showPassword ? "Ocultar senha" : "Mostrar senha"}</p>
            </ShowPassword>

            <Button text="Entrar" loading={loading} />
          </LoginForm>
        </WrapLogin>
      </ContainerLogin>
    </Container>
  );
};

export default LoginPage;
